import { Permission } from '@cims-online/shared'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { useRFITrackerContext } from '../../../RFITrackerContext'
import { RequestForInformation } from '../../../RFITrackerContext/types'

export function useCreateOptions(): CreateHeaderActionOptions<RequestForInformation> {
  const {
    fetching,
    draftSubmitModal: { toggle },
  } = useRFITrackerContext()

  return {
    loading: fetching,
    entity: 'Request For Information',
    permission: Permission.CreateRequestForInformation,
    modal: { type: 'custom', toggle },
  }
}
